import React from "react";
import { useRouteError, Link } from "react-router-dom";
import "../styles/ErrorPage.css";

export default function ErrorPage() {
  const error = useRouteError();
  console.error("Caught an error:", error);

  return (
    <div className="error-container">
      <h1>Oops!</h1>
      <p>Something went wrong.</p>
      {error?.status && <p className="error-code">Error {error.status}</p>}
      {error?.statusText && <p className="error-text">{error.statusText}</p>}
      {error?.message && <p className="error-message">{error.message}</p>}
      <Link to="/" className="home-link">
        Go to Home
      </Link>
    </div>
  );
}
